import type { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import {
  Bar, CartesianGrid, ComposedChart, Legend, Line,
  ResponsiveContainer, Tooltip, XAxis, YAxis,
} from "recharts";

export interface ChartPoint {
  date: string;
  revenue_usd: number;
  llm_cost_usd: number;
  net_usd: number;
}

const wrapStyle: CSSProperties = {
  width: "100%",
  height: 280,
  background: "var(--d-ink-2)",
  border: "1px solid var(--d-line)",
  borderRadius: 22,
  padding: 16,
};

const tickStyle = {
  fontFamily: "var(--font-mono)",
  fontSize: 11,
  fill: "rgba(236,232,245,0.62)",
};

export function RevenueCostChart({ data }: { data: ChartPoint[] }): JSX.Element {
  const { t } = useTranslation("admin");
  return (
    <div data-testid="revenue-cost-chart" style={wrapStyle}>
      <ResponsiveContainer>
        <ComposedChart data={data}>
          <CartesianGrid stroke="rgba(230,220,255,0.08)" vertical={false} />
          <XAxis dataKey="date" tick={tickStyle} tickLine={false} axisLine={false} />
          <YAxis tick={tickStyle} tickLine={false} axisLine={false} width={48} />
          <Tooltip contentStyle={{
            background: "var(--d-ink-3)",
            border: "1px solid var(--d-line-2)",
            borderRadius: 12,
            fontFamily: "var(--font-mono)",
            fontSize: 12,
            color: "var(--d-fg)",
          }} />
          <Legend wrapperStyle={{ fontFamily: "var(--font-body)", fontSize: 12 }} />
          <Bar dataKey="revenue_usd" name={t("economics.chart.revenue")} fill="var(--d-gold)" radius={[4,4,0,0]} />
          <Bar dataKey="llm_cost_usd" name={t("economics.chart.cost")} fill="var(--d-ember)" radius={[4,4,0,0]} />
          <Line type="monotone" dataKey="net_usd" name={t("economics.chart.net")}
                stroke="var(--d-violet-soft)" strokeWidth={2} dot={false} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
